<template>
	<div class="bg-white px-3 index">
		<div class="add_tits" ref="titles">
			<el-form class="form-inlines u-f u-jsb" :inline="true">
				<div>
					<el-form-item label="模糊搜索">
						<el-input v-model="name" placeholder="请输入内容" size="small"></el-input>
					</el-form-item>
					<el-form-item label="状态">
						<el-select v-model="lb_value" placeholder="请选择" clearable size="small" filterable>
							<el-option v-for="item in  lb_options" :key="item.id" :label="item.text" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="时间">
						<el-date-picker v-model="times" size="small" type="daterange" value-format="yyyy-MM-dd"
							range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
					</el-form-item>
				</div>
			</el-form>
		</div>
		<div class="ibox-content">
			<el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
				<el-table-column prop="create_user" label="用户ID" show-overflow-tooltip></el-table-column>
				<el-table-column prop="user.nickname" label="昵称" show-overflow-tooltip></el-table-column>
				<el-table-column prop="pay_amount" label="金额" show-overflow-tooltip></el-table-column>
				<el-table-column prop="order_num" label="订单号" width="150" show-overflow-tooltip></el-table-column>
				<el-table-column prop="order_num" label="支付状态" width="150" show-overflow-tooltip>
					<template slot-scope="{row}">
						{{({0:'未支付',1:'已支付'})[row.pay_status]}}
					</template>
				</el-table-column>
				<el-table-column prop="create_time" label="添加时间" width="180"></el-table-column>
				<!-- <el-table-column label="操作" width="300" align="center">
					<template slot-scope="scope">
						<el-button size="mini" type="danger" @click="handleDelet(scope.row,scope.$index)">删除</el-button>
					</template>
				</el-table-column> -->
			</el-table>
			<div class="u-f u-ac u-jsb ft_mr">
				<div></div>
				<div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[10]" :page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper" :total="count">
					</el-pagination>
				</div>
			</div>
		</div>

	</div>
</template>


<script>
	import {
		mapState
	} from 'vuex'
	import tinymce from '@/components/common/tinymce.vue';
	export default {
		components: {
			tinymce,
		},
		data() {
			return {
				lb_value: '',
				name: '',
				times: [],
				lb_options: [{
						id: 1,
						text: '已支付'
					},
					{
						id: 0,
						text: '待支付'
					},

				],
				loading: false,
				tableData: [],
				count: 0,
				currentPage: 1,
				pagesize: 10,
				height: null,
				eid: '0',
				subloading: false,
				date: xaoi.date,
			};
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			})
		},
		mounted() {
			let that = this
			that.getHeight()
			this.begin()

		},
		methods: {
			getHeight() {
				let that = this
				var titles = that.$refs.titles.offsetHeight
				that.height = window.innerHeight - titles - 200 + 'px'
				window.onresize = () => {
					var titles = that.$refs.titles.offsetHeight
					that.height = window.innerHeight - titles - 200 + 'px'
				}
			},

			// 搜索
			begin() {
				let that = this
				that.currentPage = 1
				that.pagesize = 10
				that.search()
			},
			async search() {
				let that = this
				that.tableData = []
				that.loading = true
				let params = {
					page_count: this.pagecount,
					page: this.page,
					name: that.name,
					pay_status: that.lb_value,
					start: this.times ? this.times[0] : '',
					end: this.times ? this.times[1] : '',
				}
				let res = await this.ajax('CurriculumRecord/orderList', params)
				that.loading = false
				that.tableData = res.data.data
				that.count = res.data.total
			},
			handleSizeChange(val) {
				let that = this
				that.pagesize = val;
				that.search()
			},
			handleCurrentChange(val) {
				let that = this
				that.currentPage = val;
				that.search()
			},
			// 删除
			async handleDelet(row, index) {
				let that = this
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let res = await this.ajax('acadexchange/index/del', {
						id: row.id,
						ry_value: row.create_user,
					})
					if (res.code == '200') {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						that.search()
					} else {
						that.$message.error(res.data.msg);
					}
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			gettimes() {
				let nowDate = new Date();
				let year = nowDate.getFullYear();
				let month = nowDate.getMonth() + 1;
				let day = nowDate.getDate();
				let hour = nowDate.getHours(); //获取系统时，
				let min = nowDate.getMinutes(); //分
				let sec = nowDate.getSeconds(); //秒
				month = month > 9 ? month : '0' + month
				day = day > 9 ? day : '0' + day
				hour = hour > 9 ? hour : '0' + hour
				min = min > 9 ? min : '0' + min
				sec = sec > 9 ? sec : '0' + sec
				return `${year}-${month}-${day} ${hour}:${min}`;
			},



		},

	};
</script>


<style>
	.imgs {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		margin-right: 5px;
	}

	.lefts {
		max-height: 500px;
		overflow: auto;
	}

	.delt {
		color: red;
		font-size: 20px;
	}

	.blues {
		color: #409eff;
	}

	.concon {
		background: #f5f5f5;
		padding: 10px;
		border-radius: 10px;
	}

	.zanbtn {
		width: 30px;
		display: flex;
		/* border: 1px solid red; */
		cursor: pointer;
	}

	.zanbtn img {
		width: 100%;
		display: block;
	}

	.singleimg {
		width: 100px;
		width: 100px;
	}

	.singleimg img {
		width: 100%;
		height: 100%;
		display: block;
	}

	.imgbox {
		display: flex;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>